import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';

function VerifierLoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login(username, password);
      const { token, role, name } = res.data;
      if (role !== 'VERIFIER' && role !== 'ADMIN' && role !== 'MASTER') {
        setError('Access denied. Only verifier accounts can login here.');
        setLoading(false);
        return;
      }
      localStorage.setItem('token', token);
      localStorage.setItem('username', res.data.username);
      localStorage.setItem('role', role);
      localStorage.setItem('name', name);
      navigate('/verify');
    } catch {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1a472a 0%, #2d5f3f 100%)' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '400px', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img src={process.env.PUBLIC_URL + '/misk_logo.png'} alt="MISK Logo" style={{ height: '80px', marginBottom: '15px' }} />
          <h2 style={{ color: '#2d5f3f', margin: 0 }}>Member Verification</h2>
          <p style={{ color: '#666', fontSize: '14px' }}>Login to verify members</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <input type="text" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} required
              style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required
              style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' }} />
          </div>
          {error && <p style={{ color: '#f44336', fontSize: '13px', margin: '0 0 15px' }}>{error}</p>}
          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '12px', background: '#2d5f3f', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '16px', cursor: loading ? 'wait' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default VerifierLoginPage;
